// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-header-radius th:first-child{border-top-left-radius: 15px;}
.table-header-radius th:last-child{border-top-right-radius: 15px;}
.css-11xur9t-MuiPaper-root-MuiTableContainer-root{
    border-radius: 15px 15px 0px 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,oCAAoC,4BAA4B,CAAC;AACjE,mCAAmC,6BAA6B,CAAC;AACjE;IACI,2CAA2C;AAC/C","sourcesContent":[".table-header-radius th:first-child{border-top-left-radius: 15px;}\n.table-header-radius th:last-child{border-top-right-radius: 15px;}\n.css-11xur9t-MuiPaper-root-MuiTableContainer-root{\n    border-radius: 15px 15px 0px 0px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
